import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div className="overflow-hidden">
      {/* Hero Banner */}
      <div className="relative h-[500px] md:h-[700px] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-[#DAA520] to-[#E91E63]">
          <div className="absolute inset-0 bg-black/20"></div>
        </div>
        
        <div className="relative h-full flex items-center px-4 md:px-20">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Welcome to Sasta Fashions
            </h1>
            <p className="text-white/80 text-lg mb-8">
              Explore our collection of 300+ fashion items across 3 categories
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => window.location.href = '/women'}
                className="bg-white text-[#1A1A1A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors"
              >
                Shop Women's
              </button>
              <button
                onClick={() => window.location.href = '/men'}
                className="bg-white text-[#1A1A1A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors"
              >
                Shop Men's
              </button>
              <button
                onClick={() => window.location.href = '/kids'}
                className="bg-white text-[#1A1A1A] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors"
              >
                Shop Kids
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Collections Overview */}
      <div className="py-16 px-4 md:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A1A1A] mb-4">Our Collections</h2>
            <p className="text-gray-600 text-lg mb-6 max-w-3xl mx-auto">
              Discover fashion for everyone in the family
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {/* Women's Collection */}
            <div className="bg-gradient-to-br from-[#E91E63] to-[#DAA520] rounded-lg overflow-hidden shadow-lg">
              <div className="p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">Women's Collection</h3>
                <p className="mb-6">103+ products across 5 categories</p>
                <button
                  onClick={() => window.location.href = '/women'}
                  className="bg-white text-[#E91E63] px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors"
                >
                  Browse Collection
                </button>
              </div>
            </div>
            
            {/* Men's Collection */}
            <div className="bg-gradient-to-br from-[#2196F3] to-[#DAA520] rounded-lg overflow-hidden shadow-lg">
              <div className="p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">Men's Collection</h3>
                <p className="mb-6">104+ products across 5 categories</p>
                <button
                  onClick={() => window.location.href = '/men'}
                  className="bg-white text-[#2196F3] px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors"
                >
                  Browse Collection
                </button>
              </div>
            </div>
            
            {/* Kids Collection */}
            <div className="bg-gradient-to-br from-[#4CAF50] to-[#DAA520] rounded-lg overflow-hidden shadow-lg">
              <div className="p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">Kids Collection</h3>
                <p className="mb-6">100+ products across 8 categories</p>
                <button
                  onClick={() => window.location.href = '/kids'}
                  className="bg-white text-[#4CAF50] px-6 py-2 rounded font-semibold hover:bg-gray-100 transition-colors"
                >
                  Browse Collection
                </button>
              </div>
            </div>
          </div>

          {/* Women's Collection Preview */}
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A1A1A] mb-4">Women's Collection</h2>
            <p className="text-gray-600 text-lg mb-6 max-w-3xl mx-auto">
              Discover our extensive collection of women's fashion across 5 categories
            </p>
            <button
              onClick={() => window.location.href = '/women'}
              className="bg-[#DAA520] text-white px-8 py-3 rounded font-semibold hover:bg-[#c5941c] transition-colors"
            >
              Browse All 103+ Products
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👗</div>
              <h3 className="text-lg font-semibold mb-2">Dresses</h3>
              <p className="text-gray-600 text-sm mb-3">47+ elegant designs</p>
              <button
                onClick={() => window.location.href = '/women?category=dresses'}
                className="text-[#DAA520] text-sm font-medium hover:underline"
              >
                View Dresses →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">🧣</div>
              <h3 className="text-lg font-semibold mb-2">Dupatta</h3>
              <p className="text-gray-600 text-sm mb-3">8+ beautiful styles</p>
              <button
                onClick={() => window.location.href = '/women?category=dupatta'}
                className="text-[#DAA520] text-sm font-medium hover:underline"
              >
                View Dupattas →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👚</div>
              <h3 className="text-lg font-semibold mb-2">Kurthi</h3>
              <p className="text-gray-600 text-sm mb-3">19+ traditional & modern</p>
              <button
                onClick={() => window.location.href = '/women?category=kurthi'}
                className="text-[#DAA520] text-sm font-medium hover:underline"
              >
                View Kurthis →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👖</div>
              <h3 className="text-lg font-semibold mb-2">Palazzo</h3>
              <p className="text-gray-600 text-sm mb-3">12+ stylish sets</p>
              <button
                onClick={() => window.location.href = '/women?category=palazoo'}
                className="text-[#DAA520] text-sm font-medium hover:underline"
              >
                View Palazzo →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👘</div>
              <h3 className="text-lg font-semibold mb-2">Sarees</h3>
              <p className="text-gray-600 text-sm mb-3">17+ traditional wears</p>
              <button
                onClick={() => window.location.href = '/women?category=sarees'}
                className="text-[#DAA520] text-sm font-medium hover:underline"
              >
                View Sarees →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Men's Collection Preview */}
      <div className="py-16 px-4 md:px-20 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A1A1A] mb-4">Men's Collection</h2>
            <p className="text-gray-600 text-lg mb-6 max-w-3xl mx-auto">
              Discover stylish outfits for men across 5 categories
            </p>
            <button
              onClick={() => window.location.href = '/men'}
              className="bg-[#2196F3] text-white px-8 py-3 rounded font-semibold hover:bg-[#0b7dda] transition-colors"
            >
              Browse All 104+ Products
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">🧥</div>
              <h3 className="text-lg font-semibold mb-2">Jackets</h3>
              <p className="text-gray-600 text-sm mb-3">17+ stylish designs</p>
              <button
                onClick={() => window.location.href = '/men?category=jacket'}
                className="text-[#2196F3] text-sm font-medium hover:underline"
              >
                View Jackets →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👕</div>
              <h3 className="text-lg font-semibold mb-2">Kurtas</h3>
              <p className="text-gray-600 text-sm mb-3">27+ traditional styles</p>
              <button
                onClick={() => window.location.href = '/men?category=kurta'}
                className="text-[#2196F3] text-sm font-medium hover:underline"
              >
                View Kurtas →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👖</div>
              <h3 className="text-lg font-semibold mb-2">Pants</h3>
              <p className="text-gray-600 text-sm mb-3">18+ comfortable pairs</p>
              <button
                onClick={() => window.location.href = '/men?category=pants'}
                className="text-[#2196F3] text-sm font-medium hover:underline"
              >
                View Pants →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👔</div>
              <h3 className="text-lg font-semibold mb-2">Shirts</h3>
              <p className="text-gray-600 text-sm mb-3">22+ elegant styles</p>
              <button
                onClick={() => window.location.href = '/men?category=shirts'}
                className="text-[#2196F3] text-sm font-medium hover:underline"
              >
                View Shirts →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👕</div>
              <h3 className="text-lg font-semibold mb-2">T-Shirts</h3>
              <p className="text-gray-600 text-sm mb-3">20+ casual designs</p>
              <button
                onClick={() => window.location.href = '/men?category=tshirts'}
                className="text-[#2196F3] text-sm font-medium hover:underline"
              >
                View T-Shirts →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Kids Collection Preview */}
      <div className="py-16 px-4 md:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1A1A1A] mb-4">Kids Collection</h2>
            <p className="text-gray-600 text-lg mb-6 max-w-3xl mx-auto">
              Discover adorable outfits for your little ones across 8 categories
            </p>
            <button
              onClick={() => window.location.href = '/kids'}
              className="bg-[#4CAF50] text-white px-8 py-3 rounded font-semibold hover:bg-[#3d8b40] transition-colors"
            >
              Browse All 100+ Products
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👗</div>
              <h3 className="text-lg font-semibold mb-2">Dresses</h3>
              <p className="text-gray-600 text-sm mb-3">23+ adorable designs</p>
              <button
                onClick={() => window.location.href = '/kids?category=dresses'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Dresses →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👖</div>
              <h3 className="text-lg font-semibold mb-2">Dungarees</h3>
              <p className="text-gray-600 text-sm mb-3">12+ cute styles</p>
              <button
                onClick={() => window.location.href = '/kids?category=dungaree'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Dungarees →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">🧥</div>
              <h3 className="text-lg font-semibold mb-2">Jackets</h3>
              <p className="text-gray-600 text-sm mb-3">15+ warm designs</p>
              <button
                onClick={() => window.location.href = '/kids?category=jacket'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Jackets →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👕</div>
              <h3 className="text-lg font-semibold mb-2">Kurtas</h3>
              <p className="text-gray-600 text-sm mb-3">19+ festive styles</p>
              <button
                onClick={() => window.location.href = '/kids?category=kurta'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Kurtas →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👘</div>
              <h3 className="text-lg font-semibold mb-2">Lehengas</h3>
              <p className="text-gray-600 text-sm mb-3">16+ beautiful sets</p>
              <button
                onClick={() => window.location.href = '/kids?category=lehanga'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Lehengas →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">🛏️</div>
              <h3 className="text-lg font-semibold mb-2">Night Suits</h3>
              <p className="text-gray-600 text-sm mb-3">14+ comfortable sets</p>
              <button
                onClick={() => window.location.href = '/kids?category=night_suits'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Night Suits →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👕</div>
              <h3 className="text-lg font-semibold mb-2">T-Shirts</h3>
              <p className="text-gray-600 text-sm mb-3">19+ fun designs</p>
              <button
                onClick={() => window.location.href = '/kids?category=tshirt'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View T-Shirts →
              </button>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="text-3xl mb-3">👕</div>
              <h3 className="text-lg font-semibold mb-2">Tracksuits</h3>
              <p className="text-gray-600 text-sm mb-3">9+ sporty sets</p>
              <button
                onClick={() => window.location.href = '/kids?category=tracksuit'}
                className="text-[#4CAF50] text-sm font-medium hover:underline"
              >
                View Tracksuits →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
    </div>
  );
};

export default HomePage;